// extracted by mini-css-extract-plugin
export var component = "focusWithin-module--component--Vckj7";
export var outset = "focusWithin-module--outset--O4I9G";